// Gender utility functions for consistent handling across the application

/**
 * Convert gender enum value to user-friendly display format
 * @param {string} gender - Gender enum value (MALE, FEMALE, OTHER, or lowercase variants)
 * @returns {string} - User-friendly display format
 */
export const getGenderDisplayLabel = (gender) => {
  if (!gender) return 'N/A';
  
  const genderMap = {
    'MALE': 'Male',
    'FEMALE': 'Female', 
    'OTHER': 'Other',
    'male': 'Male',    // Backward compatibility
    'female': 'Female',
    'other': 'Other'
  };
  
  return genderMap[gender] || gender;
};

/**
 * Convert gender enum value to form value format (uppercase)
 * @param {string} gender - Gender value from any format
 * @returns {string} - Uppercase enum value for form submission
 */
export const getGenderFormValue = (gender) => {
  if (!gender) return '';
  
  const genderMap = {
    'MALE': 'MALE',
    'FEMALE': 'FEMALE', 
    'OTHER': 'OTHER',
    'male': 'MALE',    // Backward compatibility
    'female': 'FEMALE',
    'other': 'OTHER'
  };
  
  return genderMap[gender] || '';
};

/**
 * Get all available gender options for form selects
 * @returns {Array} - Array of gender options with value and label
 */
export const getGenderOptions = () => [
  { value: '', label: 'Select Gender' },
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'other', label: 'Other' }
];
